import 'twin.macro';

// Digits are rendered with tabular-nums and a fixed character width so the pill
// never resizes as the value ticks (1 -> 10, 0:09 -> 0:10). The rep total is
// dimmed to white/60 — it's context, not the live number the user is tracking.
const TimerOrCounter = ({ hasCounter, counterCurrentValue, counterTotal, minutes, seconds }) => {
  if (!hasCounter) {
    const hasTotal = typeof counterTotal === 'number' && counterTotal > 0;
    // No live value (offline: nothing is counting reps) — the prescribed target
    // becomes the hero number on its own instead of reading as "0 done".
    const hasLiveValue = counterCurrentValue !== null && counterCurrentValue !== undefined;

    if (!hasLiveValue) {
      return (
        <p
          tw="flex items-baseline text-[34px] text-white font-semibold tabular-nums"
          data-testid="time-counter"
        >
          <span tw="min-w-[2ch] text-right">{hasTotal ? counterTotal : '-'}</span>
        </p>
      );
    }

    return (
      <p tw="flex items-baseline text-[34px] text-white font-semibold tabular-nums">
        <span tw="min-w-[2ch] text-right" data-testid="rep-counter">
          {counterCurrentValue}
        </span>
        {hasTotal && (
          <span tw="text-white/60" data-testid="rep-total">
            /<span tw="inline-block min-w-[2ch] text-left">{counterTotal}</span>
          </span>
        )}
      </p>
    );
  }

  const formattedTime = `${minutes > 0 ? `${minutes}:` : ''}${
    seconds < 10 ? `0${seconds}` : seconds
  }`;

  return (
    <p
      tw="min-w-[4ch] text-center text-[34px] text-white font-semibold tabular-nums [font-family: Roboto, sans-serif]"
      data-testid="format-timer"
    >
      {formattedTime}
    </p>
  );
};
export default TimerOrCounter;
